import { formatCurrency } from '../data';
import { trackingSteps } from '../pages/liveTrackingStatus';

export function TrackingProgress({ index }) {
  return (
    <ol className="live-track-steps" aria-label="Order progress">
      {trackingSteps.map((label, position) => (
        <li
          key={label}
          className={
            position < index
              ? 'done'
              : position === index
                ? 'current'
                : ''
          }
        >
          <span>{position < index ? '✓' : position + 1}</span>
          <strong>{label}</strong>
        </li>
      ))}
    </ol>
  );
}

export function TrackingAddress({ address }) {
  if (!address) return null;
  const isPickup = address.region === 'pickup';
  const lines = isPickup
    ? ['Store pickup', address.city]
    : [
        address.address_line_1,
        address.address_line_2,
        address.city,
        address.region
      ];

  return (
    <section className="live-track-block">
      <h3>{isPickup ? 'Pickup' : 'Delivering to'}</h3>
      <p>
        {lines.filter(Boolean).map((line) => (
          <span key={line}>{line}</span>
        ))}
      </p>
    </section>
  );
}

export function TrackingItems({ items, total }) {
  if (!items?.length) return null;
  return (
    <section className="live-track-block">
      <h3>Your items</h3>
      <div className="live-track-items">
        {items.map((item, position) => (
          <article key={`${item.product_name}-${position}`}>
            {item.image_url && (
              <img src={item.image_url} alt={`${item.product_name} saree`} />
            )}
            <div>
              <strong>{item.product_name}</strong>
              <span>
                {item.variant_name ? `${item.variant_name} · ` : ''}
                Quantity {item.quantity}
              </span>
            </div>
          </article>
        ))}
      </div>
      {total !== undefined && total !== null && (
        <p className="live-track-total">
          <span>Order total</span>
          <strong>{formatCurrency(total)}</strong>
        </p>
      )}
    </section>
  );
}